<template>
  <MasterclassFormBase :isEdit="false" />
</template>

<script setup>
import MasterclassFormBase from "@/components/admin/ysa/MasterclassFormBase.vue";
</script>
